import { LangCode } from '../common/api-response.model';
import { Pager } from '../common/pagination.model';

// Old

export interface OneBrandResponse {
  id: number;

  // Basic brand info
  slug: string;
  image_url: string | null;

  // Brand Profile
  brand_profile_image_url: string | null;

  // Desktop Cover Banners
  desktop_brand_cover_banner_url_en: string | null;
  desktop_brand_cover_banner_url_ar: string | null;

  // Mobile Cover Banners
  mobile_brand_cover_banner_url_en: string | null;
  mobile_brand_cover_banner_url_ar: string | null;

  // Desktop Section Banners
  desktop_section_banner_url_en: string | null;
  desktop_section_banner_url_ar: string | null;

  // Mobile Section Banners
  mobile_section_banner_url_en: string | null;
  mobile_section_banner_url_ar: string | null;

  // Extra fields the UI expects
  is_premium: boolean;
  position: number | null;
  gradient_color_1: string | null;
  gradient_color_2: string | null;
  // Optional count field (from your old interface)
  cached_product_count?: number;

  brand_translations: BrandTranslations[];
}

export interface BrandTranslations {
  language: LangCode;
  name: string;
  brand_id: number;
  createdAt?: Date;
}

// Post-refactor

export interface BrandsResponse extends Pager {
  records: BrandInfoResponse[];
}

export interface BrandInfoResponse {
  id: number;
  name?: string;
  image_url: string;
  slug: string;
  cached_product_count: number;
  createdAt?: Date;
  translation: BrandTranslationInfo;
  is_premium?: boolean;
}

export interface BrandTranslationInfo {
  __key: string;
  language: LangCode;
  name: string;
  brand_id: number;
  createdAt?: Date;
}

export interface BrandInfoNewResponse {
  id: string;
  image_url: string;
  slug: string;
  cached_product_count: number;
  brand_profile_image_url: string;
  is_premium: boolean;
  position: number;
  gradient_color_1: string;
  gradient_color_2: string;
  createdAt: string;
  updatedAt: string;
  deleted_at: string | null;
  brand_translations: BrandTranslation[];
}

export interface BrandTranslation {
   brand_id: string;
  language: string;
  name: string;
  desktop_brand_cover_banner_url: string;
  mobile_brand_cover_banner_url: string;
  desktop_section_banner_url: string;
  mobile_section_banner_url: string;
  seo_title?: string;
  seo_keywords?: string;
  meta_description?: string;
  createdAt: string;
  updatedAt: string;
}

export interface BrandRecordsResponse extends Pager {
  records: BrandInfoNewResponse[];
}
export interface SingleBrandResponse {
  id: string;
  image_url: string;
  slug: string;
  cached_product_count: number;
  brand_profile_image_url: string | null;

  desktop_brand_cover_banner_url_en: string | null;
  desktop_brand_cover_banner_url_ar: string | null;

  mobile_brand_cover_banner_url_en: string | null;
  mobile_brand_cover_banner_url_ar: string | null;

  desktop_section_banner_url_en: string | null;
  desktop_section_banner_url_ar: string | null;

  mobile_section_banner_url_en: string | null;
  mobile_section_banner_url_ar: string | null;

  is_premium: boolean;
  position: number | null;

  gradient_color_1: string | null;
  gradient_color_2: string | null;

  createdAt: string;
  updatedAt: string;
  deleted_at: string | null;

  translations: BrandTranslation[];
}
export interface BrandRecordsResponseUser extends Pager {
  records: BrandResponseUser[];
}
export interface BrandResponseUser {
  id: string;
  image_url: string;
  slug: string;
  cached_product_count: number;
  brand_profile_image_url: string | null;
  is_premium: boolean;
  position: number | null;
  gradient_color_1: string | null;
  gradient_color_2: string | null;
  createdAt: string;
  updatedAt: string;
  deleted_at: string | null;
  translation: BrandTranslation;
}
export interface brandBannerResponse  extends Pager {
  records: CarouselItem[];
}

export interface CarouselItem {
  id: string;
  position: number;
  banner_type: string;
  entity_type: string;
  banner_value: string;
  createdAt: string;
  updatedAt: string;
  translation: BrandBannerTranslation;
}

export interface BrandBannerTranslation {
  __key: string;
  id: string;
  language: string;
  carousel_item_id: string;
  view_type: ViewType;
  createdAt: string;
  updatedAt: string;
}

export interface ViewType {
  mobile: ViewImage;
  desktop: ViewImage;
}

export interface ViewImage {
  image_url: string;
}
export interface BrandBannerResponse {
  id: string;
  position: number;
  banner_type: string;
  entity_type: string;
  banner_value: string;
  createdAt: string;
  updatedAt: string;
  translations: BrandBannerTranslation[];
}
